import { MenuItemOptions } from "@finanedi.es/storybook"
import { faDownload, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import { ESTADO_CONCILIACION } from "api/Types/EstadoConciliacion"
import { TIPO_CONCILIACION } from "api/Types/TipoConciliacion"
import { TipoTransaccionType } from "api/Types/TipoTransaccionEnum"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"

export const getOptions = (
  exportToExcel: () => void,
  handleDelete: () => void,
  t: TFunction
): MenuItemOptions[] => [
  {
    title: `${t("bancos.idView.labelDownload")}`,
    hasRedirect: false,
    icon: faDownload,
    className: "tw-text-text-50",
    action: exportToExcel,
  },
  {
    title: `${t("bancos.idView.labelDelete")}`,
    hasRedirect: false,
    icon: faTrashCan,
    className: "tw-text-danger-20",
    action: handleDelete,
  },
]

export const ConciliableWithForzosasLabel = (
  t: TFunction,
  {
    conciliacionBancariaId,
    tipoConciliacion,
    idExterno,
  }: MovimientoBancarioReadingDtoProps,
  setShowModalConciliacion: Dispatch<
    SetStateAction<{
      show: boolean
      data: MovimientoBancarioReadingDtoProps | null
    }>
  >
) => {
  return (
    <span>
      {conciliacionBancariaId !== null ||
      tipoConciliacion === TIPO_CONCILIACION.FORZADA ? (
        <span
          onClick={() =>
            setShowModalConciliacion({
              show: true,
              data: { conciliacionBancariaId, tipoConciliacion, idExterno },
            })
          }
          className='tw-cursor-pointer tw-text-info-100 tw-no-underline hover:tw-underline'
        >
          {t("bancos.statusConciliacion.conciled")}
        </span>
      ) : (
        <span className='tw-text-text'>
          {t("bancos.statusConciliacion.notConciled")}
        </span>
      )}
    </span>
  )
}

export const STATUS_CONCILIACION = ({
  t,
  onClickAction,
  conciliacionBancariaId,
}: $TSMigrationFixMe) => ({
  [ESTADO_CONCILIACION.SIN_CONCILIAR]: (
    <span className='tw-text-text'>
      {`${t("bancos.statusConciliacion.unreconciled")}`}
    </span>
  ),
  [ESTADO_CONCILIACION.CONCILIADO]: (
    <span
      onClick={onClickAction}
      className={`${onClickAction ? "tw-text-text-hyperlinks " : ""} ${
        conciliacionBancariaId ? "hover:tw-underline tw-cursor-pointer" : ""
      }`}
    >
      {t("bancos.statusConciliacion.conciled")}
    </span>
  ),
})

export type BankDetailFiltersProps = {
  cuentaBancariaId?: string
  activeCompanyId?: string
  keyword?: string
  pagination: {
    itemsPerPage: number
    skipCount: number
  }
  date: {
    min?: string
    max?: string
  }
  amount: {
    min?: number
    max?: number
  }
  movementType?: TipoTransaccionType
}

export const BANK_DETAIL_FILTERS = (
  cuentaBancariaId?: string,
  activeCompanyId?: string,
  itemsPerPage?: number
) => ({
  cuentaBancariaId,
  idExterno: null,
  activeCompanyId,
  keyword: undefined,
  pagination: {
    itemsPerPage: itemsPerPage ?? 100,
    skipCount: 0,
  },
  date: { min: undefined, max: undefined },
  amount: { min: undefined, max: undefined },
  movementType: undefined,
})
